import { BBox } from "geojson";

export function isValidBBox(bbox: unknown): bbox is BBox {
    return Array.isArray(bbox) && bbox.length === 4;
}
